export default "__VITE_ASSET__lhb2bPkp__"